import { Navigate } from "react-router-dom";

const Signup = () => {
  return <Navigate to="/auth" replace />;
};

export default Signup;
